import { render } from "./Abt1.vue?vue&type=template&id=23843a10"
import script from "./Abt1.vue?vue&type=script&lang=js"
export * from "./Abt1.vue?vue&type=script&lang=js"

import "./Abt1.vue?vue&type=style&index=0&id=23843a10&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__